import { getOutputFormat } from "../js/LocalStorageManager"
export const OutputOptions = (props: any) => {
  const { setOutputFormat } = props

  return (
    <select id="outputFormat" defaultValue = {getOutputFormat()} onChange={(event) => setOutputFormat(event.target.value)}>
      <option value=".csv">csv</option>
      <option value=".txt">txt (no timestamps)</option>
      <option value=".TextGrid">TextGrid</option>
      <option value=".eaf">eaf</option>
    </select>
  )
}
